import type { TagColor } from "@/features/tag/types";

// The palette, in picker order.
export const TAG_COLORS: readonly TagColor[] = [
  "AMBER",
  "EMERALD",
  "VIOLET",
  "BLUE",
  "ROSE",
  "SKY",
  "ORANGE",
  "SLATE",
] as const;

// Soft badge classes (low-saturation surface + dark ink), matching the app's
// source/lead badge style.
export const TAG_COLOR_CLASSES: Record<TagColor, string> = {
  AMBER: "border-transparent bg-amber-100 text-amber-700",
  EMERALD: "border-transparent bg-emerald-100 text-emerald-700",
  VIOLET: "border-transparent bg-violet-100 text-violet-700",
  BLUE: "border-transparent bg-blue-100 text-blue-700",
  ROSE: "border-transparent bg-rose-100 text-rose-700",
  SKY: "border-transparent bg-sky-100 text-sky-700",
  ORANGE: "border-transparent bg-orange-100 text-orange-700",
  SLATE: "border-transparent bg-slate-100 text-slate-700",
};

// Solid swatch dot for the colour picker.
export const TAG_COLOR_SWATCH: Record<TagColor, string> = {
  AMBER: "bg-amber-500",
  EMERALD: "bg-emerald-500",
  VIOLET: "bg-violet-500",
  BLUE: "bg-blue-500",
  ROSE: "bg-rose-500",
  SKY: "bg-sky-500",
  ORANGE: "bg-orange-500",
  SLATE: "bg-slate-500",
};
